import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

const setTag = (attr, key, val) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", val || "");
};

export const useMeta = (page, vars = {}) => {
  const { content } = useSite();
  const s = content?.seo || {};
  const fill = (t) => Object.entries(vars).reduce((a, [k, v]) => a.replaceAll(`{${k}}`, v || ""), t || "");
  const title = (page ? fill(s[`${page}_title`]) : "") || s.home_title;
  const desc = (page ? fill(s[`${page}_description`]) : "") || s.home_description;

  useEffect(() => {
    if (!title) return;
    document.title = title;
    setTag("name", "description", desc);
    setTag("property", "og:title", title);
    setTag("property", "og:description", desc);
  }, [title, desc]);
};
